import { Box, Flex, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";
import type { ExampleOfferingCategory } from "./offeringCategoryTemplates";

type Props = {
  category: ExampleOfferingCategory;
  keyContent?: ReactNode;
};

export function ExampleOfferingCategoryCard({ category, keyContent }: Props) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      bg="white"
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="xl"
      overflow="hidden"
    >
      <Flex p={4} gap={2} align={keyContent ? "flex-start" : "center"}>
        <Box flex="1" minW={0}>
          <Text fontSize="xl" fontWeight="medium" color="blackAlpha.800">
            {category.label}
          </Text>
          {keyContent ?? (
            <Text fontSize="sm" color="gray.500">
              {category.key}
            </Text>
          )}
        </Box>
      </Flex>
      {category.options.map((option) => (
        <Flex
          key={option.key}
          px={4}
          py={3}
          gap={4}
          bg="blackAlpha.50"
          borderTopWidth="1px"
          borderColor="gray.200"
        >
          <Box flex="1" minW={0}>
            <Text fontSize="sm" fontWeight="medium" color="gray.600">
              Offering option name
            </Text>
            <Text fontSize="md" color="blackAlpha.800">
              {option.label}
            </Text>
          </Box>
          <Box flex="1" minW={0}>
            <Text fontSize="sm" fontWeight="medium" color="gray.600">
              Offering option key
            </Text>
            <Text fontSize="md" color="blackAlpha.800">
              {option.key}
            </Text>
          </Box>
        </Flex>
      ))}
    </Box>
  );
}
